import {
    ADD_IFSC_MASTER_UPLOAD_SUCCESS, ADD_IFSC_MASTER_UPLOAD_FAILURE, IFSC_MASTER_TEMPLATE_SUCCESS, IFSC_MASTER_TEMPLATE_FAILURE,
    IFSC_MASTER_DATA_EXCEL_SUCCESS,
    IFSC_MASTER_DATA_EXCEL_FAILURE,
} from './action';
const initialState = {
    addIfscMasterUploadSuccess: [],
    addIfscMasterUploadFailure: [],
    ifscMasterListSuccess: null,
    ifscMasterListFailure: null
}

const ifscMasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_IFSC_MASTER_UPLOAD_SUCCESS:
            return state = {
                ...state,
                addIfscMasterUploadSuccess: action
            }
        case ADD_IFSC_MASTER_UPLOAD_FAILURE:
            return state = {
                ...state,
                addIfscMasterUploadFailure: action
            }

            case IFSC_MASTER_TEMPLATE_SUCCESS:
                return {
                    ...state,
                    ifscMasterTemplateSuccess: action.data
                }

        case IFSC_MASTER_TEMPLATE_FAILURE:
            return {
                ...state,
                ifscMasterTemplateFailure: action.data
            }

            case IFSC_MASTER_DATA_EXCEL_SUCCESS:
                return {
                    ...state,
                    ifscMasterDataExcelSuccess: action.data
                }

        case IFSC_MASTER_DATA_EXCEL_FAILURE:
            return {
                ...state,
                ifscMasterDataExcelFailure: action.data
            }
            case 'IFSC_MASTER_LIST_SUCCESS':
                return {
                    ...state,
                    ifscMasterListSuccess: action.data
                }

                case 'IFSC_MASTER_LIST_FAILURE':
                    return{
                        ...state,
                        ifscMasterListFailure: action.data
                    }
        default: return state
    }
}
export default ifscMasterReducer;
